import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import { format, parse } from "date-fns";
import { getClassTypeName } from "../../constants/classTypes";

const OverlapConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  overlappingEvents,
}) => {
  const formatTime = (timeStr) => {
    try {
      const date = parse(timeStr, "HH:mm", new Date());
      return format(date, "h:mm a");
    } catch {
      return timeStr;
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>
          <FaExclamationTriangle className="me-2" />
          Schedule Overlap Detected
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3">
          <strong>Warning:</strong> The class you're trying to create overlaps
          with existing classes. Please review the conflicts below.
        </Alert>

        <h6 className="mb-3">Conflicting Classes:</h6>
        <div className="list-group">
          {overlappingEvents.map((event, index) => (
            <div key={index} className="list-group-item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">
                    {event.title ||
                      getClassTypeName(event.type || event.classType) ||
                      "Unknown Class"}
                  </h6>
                  <small className="text-muted">
                    {event.start && event.end ? (
                      <>
                        {formatTime(
                          typeof event.start === "string"
                            ? event.start.split("T")[1]?.substring(0, 5)
                            : format(new Date(event.start), "HH:mm")
                        )}{" "}
                        -{" "}
                        {formatTime(
                          typeof event.end === "string"
                            ? event.end.split("T")[1]?.substring(0, 5)
                            : format(new Date(event.end), "HH:mm")
                        )}
                      </>
                    ) : (
                      "Time unavailable"
                    )}
                  </small>
                </div>
                {event.coach_name && (
                  <span className="badge bg-primary">{event.coach_name}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <Alert variant="info" className="mt-3 mb-0">
          <strong>Note:</strong> Creating this class will result in scheduling
          conflicts. Do you want to proceed anyway?
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="warning" onClick={onConfirm}>
          Confirm & Create Anyway
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OverlapConfirmationModal;
